// extracted by mini-css-extract-plugin
module.exports = {"buttonsSection":"info_buttonsSection__2tRel","button":"info_button__ivqNu"};